<button type="button" mat-button class="action-button" (click)="addTreatment()">
  <mat-icon>add</mat-icon>
  <span class="text-xs">Treatment</span>
</button>
